/**
 * @fileoverview gRPC-Web generated client stub for acompanha.account.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/account/v1/account.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_auth_v1_auth_pb = require('../../../acompanha/auth/v1/auth_pb.js')

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.account = {};
proto.acompanha.account.v1 = require('./account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.account.v1.AccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.account.v1.AccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetAccountRequest,
 *   !proto.acompanha.account.v1.GetAccountResponse>}
 */
const methodDescriptor_AccountService_GetAccount = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetAccount',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetAccountRequest,
  proto.acompanha.account.v1.GetAccountResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetAccountResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAccount,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetAccountResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdateProfileRequest,
 *   !proto.acompanha.account.v1.UpdateProfileResponse>}
 */
const methodDescriptor_AccountService_UpdateProfile = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdateProfile',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdateProfileRequest,
  proto.acompanha.account.v1.UpdateProfileResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdateProfileResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdateProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdateProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updateProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdateProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdateProfileResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updateProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateProfile',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdatePasswordRequest,
 *   !proto.acompanha.account.v1.UpdatePasswordResponse>}
 */
const methodDescriptor_AccountService_UpdatePassword = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdatePassword',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdatePasswordRequest,
  proto.acompanha.account.v1.UpdatePasswordResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdatePasswordResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdatePasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdatePasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updatePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdatePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdatePassword,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdatePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdatePasswordResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updatePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdatePassword',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdatePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.UpdateAvatarRequest,
 *   !proto.acompanha.account.v1.UpdateAvatarResponse>}
 */
const methodDescriptor_AccountService_UpdateAvatar = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/UpdateAvatar',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.UpdateAvatarRequest,
  proto.acompanha.account.v1.UpdateAvatarResponse,
  /**
   * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.UpdateAvatarResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.UpdateAvatarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.UpdateAvatarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.updateAvatar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateAvatar',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAvatar,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.UpdateAvatarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.UpdateAvatarResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.updateAvatar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/UpdateAvatar',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAvatar);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetMySubscriptionRequest,
 *   !proto.acompanha.account.v1.GetMySubscriptionResponse>}
 */
const methodDescriptor_AccountService_GetMySubscription = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetMySubscription',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetMySubscriptionRequest,
  proto.acompanha.account.v1.GetMySubscriptionResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetMySubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetMySubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetMySubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getMySubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetMySubscription',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMySubscription,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetMySubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetMySubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getMySubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetMySubscription',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetMySubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetPlanUsageRequest,
 *   !proto.acompanha.account.v1.GetPlanUsageResponse>}
 */
const methodDescriptor_AccountService_GetPlanUsage = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetPlanUsage',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetPlanUsageRequest,
  proto.acompanha.account.v1.GetPlanUsageResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetPlanUsageResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetPlanUsageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetPlanUsageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getPlanUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetPlanUsage',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetPlanUsage,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetPlanUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetPlanUsageResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getPlanUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetPlanUsage',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetPlanUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.ListSubscriptionPlansRequest,
 *   !proto.acompanha.account.v1.ListSubscriptionPlansResponse>}
 */
const methodDescriptor_AccountService_ListSubscriptionPlans = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/ListSubscriptionPlans',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.ListSubscriptionPlansRequest,
  proto.acompanha.account.v1.ListSubscriptionPlansResponse,
  /**
   * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.ListSubscriptionPlansResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.ListSubscriptionPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.ListSubscriptionPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.listSubscriptionPlans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/ListSubscriptionPlans',
      request,
      metadata || {},
      methodDescriptor_AccountService_ListSubscriptionPlans,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.ListSubscriptionPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.ListSubscriptionPlansResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.listSubscriptionPlans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/ListSubscriptionPlans',
      request,
      metadata || {},
      methodDescriptor_AccountService_ListSubscriptionPlans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.MigratePlanRequest,
 *   !proto.acompanha.account.v1.MigratePlanResponse>}
 */
const methodDescriptor_AccountService_MigratePlan = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/MigratePlan',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.MigratePlanRequest,
  proto.acompanha.account.v1.MigratePlanResponse,
  /**
   * @param {!proto.acompanha.account.v1.MigratePlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.MigratePlanResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.MigratePlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.MigratePlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.MigratePlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.migratePlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/MigratePlan',
      request,
      metadata || {},
      methodDescriptor_AccountService_MigratePlan,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.MigratePlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.MigratePlanResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.migratePlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/MigratePlan',
      request,
      metadata || {},
      methodDescriptor_AccountService_MigratePlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.StartSubscriptionCheckoutRequest,
 *   !proto.acompanha.account.v1.StartSubscriptionCheckoutResponse>}
 */
const methodDescriptor_AccountService_StartSubscriptionCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/StartSubscriptionCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.StartSubscriptionCheckoutRequest,
  proto.acompanha.account.v1.StartSubscriptionCheckoutResponse,
  /**
   * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.StartSubscriptionCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.StartSubscriptionCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.startSubscriptionCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/StartSubscriptionCheckout',
      request,
      metadata || {},
      methodDescriptor_AccountService_StartSubscriptionCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.StartSubscriptionCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.StartSubscriptionCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.startSubscriptionCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/StartSubscriptionCheckout',
      request,
      metadata || {},
      methodDescriptor_AccountService_StartSubscriptionCheckout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest,
 *   !proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse>}
 */
const methodDescriptor_AccountService_GetSubscriptionCheckoutStatus = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetSubscriptionCheckoutStatus',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest,
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getSubscriptionCheckoutStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetSubscriptionCheckoutStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetSubscriptionCheckoutStatus,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetSubscriptionCheckoutStatusResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getSubscriptionCheckoutStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetSubscriptionCheckoutStatus',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetSubscriptionCheckoutStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest,
 *   !proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse>}
 */
const methodDescriptor_AccountService_SubmitSubscriptionPaymentProof = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/SubmitSubscriptionPaymentProof',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest,
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse,
  /**
   * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.submitSubscriptionPaymentProof =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/SubmitSubscriptionPaymentProof',
      request,
      metadata || {},
      methodDescriptor_AccountService_SubmitSubscriptionPaymentProof,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.SubmitSubscriptionPaymentProofResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.submitSubscriptionPaymentProof =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/SubmitSubscriptionPaymentProof',
      request,
      metadata || {},
      methodDescriptor_AccountService_SubmitSubscriptionPaymentProof);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.account.v1.GetIntegrationsRequest,
 *   !proto.acompanha.account.v1.GetIntegrationsResponse>}
 */
const methodDescriptor_AccountService_GetIntegrations = new grpc.web.MethodDescriptor(
  '/acompanha.account.v1.AccountService/GetIntegrations',
  grpc.web.MethodType.UNARY,
  proto.acompanha.account.v1.GetIntegrationsRequest,
  proto.acompanha.account.v1.GetIntegrationsResponse,
  /**
   * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.account.v1.GetIntegrationsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.account.v1.GetIntegrationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.account.v1.GetIntegrationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.account.v1.AccountServiceClient.prototype.getIntegrations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetIntegrations',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetIntegrations,
      callback);
};


/**
 * @param {!proto.acompanha.account.v1.GetIntegrationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.account.v1.GetIntegrationsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.account.v1.AccountServicePromiseClient.prototype.getIntegrations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.account.v1.AccountService/GetIntegrations',
      request,
      metadata || {},
      methodDescriptor_AccountService_GetIntegrations);
};


module.exports = proto.acompanha.account.v1;

